import { createContentPropTypes } from '../../../../helpers/content';

const content = {
	exoticCurrencyDescription:
		'Sorry, we’re not able to provide you with a real-time exchange rate for this currency online. Please give us a call on {contactNumber} to book an exchange rate then enter the details you’re provided with below.',
	preBookHeader: 'Exchange rate has been pre-booked',
	header: 'Pre-booked exchange rate',
	description:
		'Please enter your six-digit reference and exchange rate you were provided with. Take care when entering these details as any mistakes could delay your payment being made.',
	referenceHeader: 'Reference',
	exchangeRateHeader: 'Exchange rate',
};

export const contentPropTypes = createContentPropTypes(content);

export default content;
